import { registerAction, registerInteraction } from '@antv/g2';
import { ConversionTagAction } from './funnel-conversion-tag';
var FUNNEL_CONVERSION_TAG = 'funnel-conversion-tag';
export var FUNNEL_LEGEND_FILTER = 'funnel-afterrender';
export var interactionStart = { trigger: 'afterrender', action: FUNNEL_CONVERSION_TAG + ":change" };
registerAction(FUNNEL_CONVERSION_TAG, ConversionTagAction);
registerInteraction(FUNNEL_LEGEND_FILTER, {
    start: [interactionStart],
});
//# sourceMappingURL=index.js.map